import React from 'react'
import PropTypes from 'prop-types'
import FormItem from './FormItem'
import {
  SEARCH_PARAM_CLIENT_CODE,
  SEARCH_PARAM_CONTRACT_NUMBER,
  SEARCH_PARAM_IATA_CODE,
  SEARCH_PARAM_PROMO_CODE,
} from '../../../../constants'

import './codeform.scss'

const CodeForm = ({
  labels, placeholders, codeChange, activeField, values, validate, syncErrors,
}) => (
  <div className="code-form">
    <FormItem
      label={labels[SEARCH_PARAM_PROMO_CODE]}
      field={{
        name: SEARCH_PARAM_PROMO_CODE,
        value: values && values[SEARCH_PARAM_PROMO_CODE],
        placeholder: placeholders[SEARCH_PARAM_PROMO_CODE],
        onChange: codeChange,
        active: activeField === SEARCH_PARAM_PROMO_CODE,
        error: syncErrors && syncErrors[SEARCH_PARAM_PROMO_CODE],
      }}
    />
    <FormItem
      label={labels[SEARCH_PARAM_CLIENT_CODE]}
      field={{
        name: SEARCH_PARAM_CLIENT_CODE,
        value: values && values[SEARCH_PARAM_CLIENT_CODE],
        placeholder: placeholders[SEARCH_PARAM_CLIENT_CODE],
        onChange: codeChange,
        active: activeField === SEARCH_PARAM_CLIENT_CODE,
        error: syncErrors && syncErrors[SEARCH_PARAM_CLIENT_CODE],
      }}
    />
    <FormItem
      field={{
        name: SEARCH_PARAM_CONTRACT_NUMBER,
        value: values && values[SEARCH_PARAM_CONTRACT_NUMBER],
        placeholder: `${values && values[SEARCH_PARAM_CLIENT_CODE] ? '*' : ''}${placeholders[SEARCH_PARAM_CONTRACT_NUMBER]}`,
        onChange: codeChange,
        active: activeField === SEARCH_PARAM_CONTRACT_NUMBER,
        error: syncErrors && syncErrors[SEARCH_PARAM_CONTRACT_NUMBER],
      }}
      validate={validate}
    />
    <FormItem
      label={labels[SEARCH_PARAM_IATA_CODE]}
      field={{
        name: SEARCH_PARAM_IATA_CODE,
        value: values && values[SEARCH_PARAM_IATA_CODE],
        placeholder: placeholders[SEARCH_PARAM_IATA_CODE],
        onChange: codeChange,
        active: activeField === SEARCH_PARAM_IATA_CODE,
        error: syncErrors && syncErrors[SEARCH_PARAM_IATA_CODE],
      }}
    />
  </div>
)


CodeForm.propTypes = {
  codeChange: PropTypes.func.isRequired,
  labels: PropTypes.objectOf(PropTypes.string).isRequired,
  placeholders: PropTypes.objectOf(PropTypes.string).isRequired,
  activeField: PropTypes.string,
  values: PropTypes.objectOf(Object),
  validate: PropTypes.arrayOf(PropTypes.func),
  syncErrors: PropTypes.objectOf(PropTypes.string),
}

CodeForm.defaultProps = {
  activeField: '',
  values: null,
  validate: [],
  syncErrors: null,
}
export default CodeForm
